<template>
  <div class="header-search">
    <a-icon type="search" class="search-icon" @click="enterSearchMode"/>
    <a-auto-complete
      ref="input"
      :getPopupContainer="e => {return e.ownerDocument.body || document.body}"
      :class="['search-input', searchMode ? 'enter' : 'leave']"
      placeholder="站内搜索"
      @search="onSearchMenu"
      @select="onSelectMenu"
      @blur="leaveSearchMode"
    >
      <template slot="dataSource">
        <a-select-option v-for="(item, index) in dataSource" :key="index" :value="item.menuId">{{ item.menuName }}</a-select-option>
      </template>
    </a-auto-complete>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'HeaderSearch',
  data () {
    return {
      dataSource: [],
      searchMode: false
    }
  },
  computed: {
    ...mapState({
      sysMenus: (state) => state.user.sysMenus,
      mainMenu: (state) => state.permission.addRouters
    })
  },
  methods: {
    enterSearchMode () {
      this.searchMode = true
      setTimeout(() => this.$refs.input.focus(), 300)
    },
    leaveSearchMode () {
      this.searchMode = false
    },
    /** 根据关键字查询匹配的路由菜单
     * @name:
     * @param {*} value
     * @return {*}
     */
    onSearchMenu (value) {
      const filterMenu = (data, text) => {
        let result = [];
        data.forEach(menu => {
          if (!menu.children || menu.children.length === 0) {
            if (menu.menuType === "C" && menu.menuName.toLowerCase().indexOf(text) > -1) {
              menu.menuId = String(menu.menuId)
              result.push(menu);
            }
          } else {
            if (menu.menuType === "C" && menu.menuName.toLowerCase().indexOf(text) > -1) {
              menu.menuId = String(menu.menuId)
              result.push(menu);
            }
            result = result.concat(filterMenu(menu.children, text));
          }
        })
        return result;
      };
      if (value) {
        const { sysMenus } = this;
        let filterData = [];
        const text = value.toLowerCase();
        filterData = filterMenu(sysMenus, text);
        this.dataSource = filterData;
      } else {
        this.dataSource = [];
      }
    },
    /** 选择菜单路由跳转
     * @name:
     * @param {*} value
     * @return {*}
     */
    onSelectMenu (value) {
      const tempPath = this.findMenuByMenuId(this.mainMenu, value)
      console.log(tempPath)
      if (this.$route.fullPath !== tempPath) {
        this.$router.push({ path: tempPath })
      }
    },
    findMenuByMenuId(menuDataArray, targetMenuId) {
      const findMenuInObject = (menuObject, targetMenuId) => {
        if (menuObject.meta && menuObject.meta.menuId.toString() === targetMenuId.toString()) {
          return menuObject.fullPath;
        }

        if (menuObject.children) {
          for (const child of menuObject.children) {
            const result = findMenuInObject(child, targetMenuId);
            if (result) {
              return result;
            }
          }
        }
        return null; // Not found in this object and its children
      }
      for (let i = 0; i < menuDataArray.length; i++) {
        const element = menuDataArray[i];
        const result = findMenuInObject(element, targetMenuId);
        if (result) {
          return result;
        }
      }
      return null; // Not found
    }
  }
}
</script>

<style lang="less">
  .header-search{
    .search-icon{
      font-size: 16px;
      cursor: pointer;
    }
    .search-input{
      border: 0;
      border-bottom: 1px solid #f0f0f0;
      transition: width 0.3s ease-in-out;
      input{
        border: 0;
        box-shadow: 0 0 0 0;
      }
      &.leave{
        width: 0px;
        input{
          display: none !important;
        }
      }
      &.enter{
        width: 200px;
        input:focus{
          box-shadow: 0 0 0 0;
        }
      }
    }
  }
</style>
